/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class StorageConfigurationBaseForAzureSaas extends models.StorageConfigurationForSaasUserManaged {
    getFixupPrototypeFunction() { return StorageConfigurationBaseForAzureSaas.fixupPrototype; }

    static newInstance(model: Partial<StorageConfigurationBaseForAzureSaas>): StorageConfigurationBaseForAzureSaas {
        let obj = Object.assign(new StorageConfigurationBaseForAzureSaas(), model);
        StorageConfigurationBaseForAzureSaas.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<StorageConfigurationBaseForAzureSaas>): StorageConfigurationBaseForAzureSaas {
        if (!model) return null;
        return StorageConfigurationBaseForAzureSaas.newInstance(<StorageConfigurationBaseForAzureSaas> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: StorageConfigurationBaseForAzureSaas) {
        if (!obj) return;

        models.StorageConfigurationBaseForAzureSaas.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: StorageConfigurationBaseForAzureSaas): boolean {
        if (models.StorageConfigurationForSaasUserManaged.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, StorageConfigurationBaseForAzureSaas.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Azure Blob Container Name. Stored as storage_account_name/container_name.
     */
    container_name: string;

    /**
     * File Path in the Container
     */
    file_path: string;

}
